(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/common/assets/javascripts/error/utils.js') >= 0) return;  svs.modules.push('/components/payment/common/assets/javascripts/error/utils.js');
"use strict";


const {
  logger
} = svs.components.payment.common;
const {
  ClientErrorCodes,
  ErrorFacillityCodes
} = svs.components.payment.common.error.constants;
const getTitleAndErrorMessageFromClientError = clientCode => {
  switch (clientCode) {
    case ClientErrorCodes.GENERIC:
      return {
        title: 'Tekniskt fel',
        message: 'Något gick fel vid betalningen, försök igen om en liten stund.'
      };
    case ClientErrorCodes.NOT_ENOUGH_DATA:
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen, vänligen försök igen senare.'
      };
    case ClientErrorCodes.NOT_PAYABLE:
    case ClientErrorCodes.NOT_WAGER:
      return {
        title: 'Tekniskt fel',
        message: 'Något gick fel vid betalningen.'
      };
    case ClientErrorCodes.NOT_ENOUGH_MONEY:
      return {
        title: 'För lite pengar',
        message: 'Ditt spelsaldo har inte tillräckligt med pengar.'
      };
    case ClientErrorCodes.NOT_AUTHENTICATED:
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen, vänligen försök igen senare.'
      };
    case ClientErrorCodes.PAYMENT_REQUEST_FAILURE:
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen, vänligen försök igen senare.'
      };
    case ClientErrorCodes.PAYMENT_FETCH_FAILURE:
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen, vänligen försök igen senare.'
      };
    case ClientErrorCodes.IMPOSSIBLE_ROWS:
      return {
        title: 'Omöjlig spelkombination',
        message: 'Spelet gick inte att betala på grund av att spelkombinationen inte är möjlig att vinna på.<br />'
      };
    case ClientErrorCodes.USER_HAS_EXCLUSION:
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen.'
      };
    case ClientErrorCodes.BAD_DRAW:
      return {
        title: 'Stängt för spel',
        message: 'Spelomgången går inte att spela på just nu.'
      };
    case ClientErrorCodes.BACKEND_ERROR:
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen, vänligen försök igen senare.'
      };
    case ClientErrorCodes.BAD_RESULT:
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen, vänligen försök igen senare.'
      };
    case ClientErrorCodes.CUSTOMER_LIMIT:
      return {
        title: 'Du har överskridit en gräns',
        message: 'Något gick fel vid betalningen, du har överskridit en gräns.'
      };
    case ClientErrorCodes.BAD_BET:
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen, vänligen försök igen senare.'
      };
    case ClientErrorCodes.TIME_LIMIT:
      return {
        title: 'Du har nått din tidsgräns',
        message: 'När du nått din tidsgräns kan du inte betala för spel på Sport & Casino.'
      };
    case ClientErrorCodes.PLAYER_PAUSED:
      return {
        title: 'Ditt konto är spärrat',
        message: 'Kontakta kundservice för mer information.'
      };
    case ClientErrorCodes.AMOUNT_LIMIT:
      return {
        title: 'Du har överskridit en gräns',
        message: 'Högsta totala insats på omgången har överskridits.'
      };
    case ClientErrorCodes.DAILY_AMOUNT_LIMIT:
      return {
        title: 'Du har överskridit en gräns',
        message: 'Högsta totala dagliga insats på denna produkt har överskridits.'
      };
    case ClientErrorCodes.ROW_LIMIT:
      return {
        title: 'Du har överskridit en gräns',
        message: 'Högsta antalet rader på denna omgång har överskridits.'
      };
    case ClientErrorCodes.COMPETITION_ERROR:
      return {
        title: 'Något gick fel',
        message: 'Det går tyvärr inte att spela på tävlingen just nu.'
      };
    case ClientErrorCodes.PAYMENT_REQUEST_FAILURE_RACING:
      return {
        title: 'Betalningen misslyckades',
        message: 'Just nu har vi problem med att ansluta till vår samarbetspartner, vänligen försök igen senare.'
      };
    case ClientErrorCodes.BAD_DRAW_RACING_CANCELLED_PARTICIPANT:
      return {
        title: 'Struken häst',
        message: 'Spelet går inte att lägga eftersom en eller flera av dina valda hästar har strukits.'
      };
    case ClientErrorCodes.BAD_DRAW_RACING_RACE_STARTED:
      return {
        title: 'Stängt för spel',
        message: 'Loppet har startat och vi tar inte emot fler spel.'
      };
    case ClientErrorCodes.BAD_DRAW_RACING_RACE_NOT_OPENED:
      return {
        title: 'Stängt för spel',
        message: 'Loppet har inte öppnat för spel, vänligen försök senare.'
      };
    case ClientErrorCodes.BAD_DRAW_RACING_REG_BET_DISABLED:
      return {
        title: 'Stängt för spel',
        message: 'Just nu går det inte att lägga detta spel, vänligen försök senare.'
      };
    default:
      return {
        title: 'Något gick fel',
        errorMessage: 'Något gick fel vid betalningen'
      };
  }
};
const getErrorCodeValue = errorCode => (errorCode === null || errorCode === void 0 ? void 0 : errorCode.split(' ')) || [];
const getClientCode = errorCode => {
  let facillity;
  let code;
  let error;
  if (errorCode) {
    [facillity, code] = getErrorCodeValue(errorCode);
    const facillityCodes = ErrorFacillityCodes[facillity];
    if (facillityCodes) {
      const facillityCodeValues = Object.values(ErrorFacillityCodes[facillity]);
      error = facillityCodeValues.find(value => value.code === code);
    } else {
      logger.info("Unhandled error, errorCode: ".concat(errorCode));
    }
  }
  return error ? error : {
    clientCode: ClientErrorCodes.GENERIC
  };
};
setGlobal('svs.components.payment.common.error.utils', {
  getErrorCodeValue,
  getTitleAndErrorMessageFromClientError,
  getClientCode
});

 })(window);